import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "text-left",
  "data-testid": "upload-quality-warnings-step"
}
const _hoisted_2 = { class: "border border-alert bg-orange-50 rounded-lg px-4 py-3" }
const _hoisted_3 = {
  class: "text-md font-bold text-textPrimary m-0",
  "data-testid": "upload-quality-warnings-title"
}
const _hoisted_4 = { class: "list-disc pl-5 mt-2 mb-0 text-sm text-textPrimary" }
const _hoisted_5 = {
  class: "text-xs text-neutral50 mt-3",
  "data-testid": "upload-quality-warnings-hint"
}

import { computed } from 'vue'
import { qualityWarningsTitle, translateQualityWarnings } from './quality-warnings'

/**
 * Eixo 2B — painel de avisos de qualidade da imagem. Nunca bloqueia: sem `warnings` o
 * componente não é montado pelo modal.
 */


export default /*#__PURE__*/_defineComponent({
  __name: 'StepWarnings',
  props: {
    warnings: {},
    phase: { default: 'BEFORE_SEND' }
  },
  setup(__props: any) {

const props = __props;



const messages = computed(() => translateQualityWarnings(props.warnings))

const hint = computed(() =>
  props.phase === 'BEFORE_SEND'
    ? 'A folha ainda não foi enviada. "Refazer a foto" volta ao passo do arquivo para escolher uma imagem melhor; "Continuar assim mesmo" segue com esta.'
    : 'O registro já foi enviado com esta folha. Para trocá-la, a Auditoria precisa reprovar o registro pedindo uma nova folha.'
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(qualityWarningsTitle)(messages.value.length)), 1),
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (message, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            "data-testid": "upload-quality-warning"
          }, _toDisplayString(message), 1))
        }), 128))
      ])
    ]),
    _createElementVNode("p", _hoisted_5, _toDisplayString(hint.value), 1)
  ]))
}
}

})